const consumerUnits = [
  { value: 'single', text: '1 unidade' },
  { value: 'between_1_and_5', text: '1 - 5 unidades' },
  { value: 'between_5_and_10', text: 'de 5 - 10 unidades' },
  { value: 'more_than_10', text: 'acima de 10 unidades' }
]
export const FreeMarketLeadFieldsOptions = {
  consumerUnits
}
